import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptyProjectModel, IProjectModel } from "./ProjectsApp";
import { ISearchParam } from "../BaseApp";

interface IProjectsState {
    projects: IProjectModel[],
    loading: boolean,
    selectedProjects: IProjectModel[],
    searchParams: ISearchParam[],
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: IProjectsState = {
    projects: [],
    loading: false,
    selectedProjects: [],
    searchParams: [],
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const projectsSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        updateAllProjects: (state: IProjectsState, action: PayloadAction<IProjectModel[]>) => {
            state.projects = action.payload
        },
        addNewProject: (state: IProjectsState, action: PayloadAction<IProjectModel>) => {
            let projects = state.projects

            if (projects.filter(project => project.id === action.payload.id).length === 0){
                state.projects.push(action.payload)
            }

        },
        deleteProject: (state: IProjectsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let projects = state.projects

            projects = projects.filter(project => project.id !== payload.id)

            state.projects = projects

        },
        updateProject: (state: IProjectsState, action: PayloadAction<IProjectModel>) => {
            let projects = state.projects
            
            if (projects && projects.length > 0){
                projects.map((project) => {
                    if (project.id === action.payload.id){

                        const locationIndex = projects.findIndex(project => project.id === action.payload.id)
                        projects[locationIndex] = action.payload

                    }
                })
            }

            state.projects = projects

        },
        updateProjectsLoadingStatus: (state: IProjectsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateProjectsPagination: (state: IProjectsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateProjectsSearch: (state: IProjectsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        setSelectedProjects: (state: IProjectsState, action: PayloadAction<IProjectModel[]>) => {
            state.selectedProjects = action.payload
        },
        setProjectsSearchParams: (state: IProjectsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
    }
})

/**
 * Return all Projects
 */
export const useReturnAllProjects = () => useSelector((state: RootState) => state.projects.projects)

/**
 * Retrun single brand
 */
export const useReturnSingleProject = (id: number) => {
    const projects = useReturnAllProjects()

    let project: IProjectModel = EmptyProjectModel

    if (projects.length > 0){
        projects.map((singleProject) => {
            if (singleProject.id === id){
                project = singleProject
            }
        })
    }

    return project

}

/**
 * Return Projects loading status
 */
export const useReturnProjectsLoadingStatus = () => useSelector((state: RootState) => state.projects.loading)

/**
 * Return Projects pagination
 */
export const useReturnProjectsPagination = () => useSelector((state: RootState) => state.projects.pagination)

/**
 * Return selected projects
 */
export const useReturnSelectedProjects = () => useSelector((state: RootState) => state.projects.selectedProjects)

/**
 * Return projects search params
 */
export const useReturnProjectsSearchParams = () => useSelector((state: RootState) => state.projects.searchParams)

/**
 * Return Projects search
 */
export const useReturnProjectsSearch = () => useSelector((state: RootState) => state.projects.search)

export const { updateAllProjects, addNewProject, deleteProject, updateProject, updateProjectsLoadingStatus, updateProjectsPagination, updateProjectsSearch, setSelectedProjects, setProjectsSearchParams } = projectsSlice.actions
export default projectsSlice.reducer